var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInnovationAndTrust(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 180,
    height: 180,
    viewBox: "0 0 180 180",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 180,
    height: 180,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M123.545 88.1102C117.938 94.1528 112.88 101.358 112.194 109.789L111.059 123.75H68.9415L67.806 109.789C67.1203 101.358 62.0622 94.1528 56.4555 88.1103C48.8804 79.9464 44.25 69.0148 44.25 57C44.25 31.733 64.733 11.25 90 11.25C115.267 11.25 135.75 31.733 135.75 57C135.75 69.0148 131.12 79.9463 123.545 88.1102Z",
    stroke: "black",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M81 142.5H99",
    stroke: "black",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M75.75 136.5H104.25",
    stroke: "black",
    strokeWidth: 1.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M71.25 130.5H108.75",
    stroke: "black",
    strokeWidth: 1.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M89.25 123.75V87.75M89.25 87.75L74.25 72.75M89.25 87.75L104.25 72.75",
    stroke: "black",
    strokeWidth: 1.5,
    strokeDasharray: "2.76 2.76"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M76.6357 50.8653C79.799 47.702 84.9276 47.702 88.0908 50.8653L101.455 64.2296L90 75.6847L76.6357 62.3204C73.4725 59.1571 73.4725 54.0285 76.6357 50.8653Z",
    fill: "#304FF2"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M103.364 50.8642C106.527 54.0275 106.527 59.1561 103.364 62.3194L89.9999 75.6837L78.5448 64.2285L91.9091 50.8642C95.0724 47.701 100.201 47.701 103.364 50.8642Z",
    fill: "#304FF2"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M55.4783 130.5C55.0901 123.807 49.5399 118.5 42.75 118.5H35.2717C35.6599 125.193 41.2101 130.5 48 130.5H55.4783Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.5
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M120.013 119.25C120.408 107.999 129.653 99 141 99H152.987C152.592 110.251 143.347 119.25 132 119.25H120.013Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInnovationAndTrust);
export default __webpack_public_path__ + "static/media/innovation_and_trust.a67f6526f60cf9e1a00eea6a1b5dd363.svg";
export { ForwardRef as ReactComponent };